import { type AddHookResponse, mutationAdd } from '../hooks'
import { toResponseError, type ConversationFeedbackAddInput, type ConversationFeedbackAddSuccess } from '@terros/common'
import { useConversationCache } from './cache'
import { useTantalimMutation } from '../mutation'

export function useAddConversationFeedback(): AddHookResponse<
  ConversationFeedbackAddInput,
  ConversationFeedbackAddSuccess
> {
  const cache = useConversationCache()

  const mutation = useTantalimMutation<ConversationFeedbackAddInput, ConversationFeedbackAddSuccess>({
    url: '/conversation/feedback/add',
  })

  async function add(updated: ConversationFeedbackAddInput): Promise<ConversationFeedbackAddSuccess> {
    try {
      const res = await mutation.mutateAsync(updated)
      cache.addFeedback(updated)
      return res
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
